/**
 * Firebase Web App Configuration
 *
 * Get these values from:
 *   Firebase Console → Project Settings → General → Your apps → Web app
 *
 * After filling in all values, also update the MATCHING placeholders in:
 *   public/firebase-messaging-sw.js  (the background service-worker copy)
 */
export const firebaseConfig = {
  apiKey:            "REPLACE_WITH_YOUR_API_KEY",
  authDomain:        "REPLACE_WITH_YOUR_AUTH_DOMAIN",       // e.g. your-project.firebaseapp.com
  projectId:         "REPLACE_WITH_YOUR_PROJECT_ID",
  storageBucket:     "REPLACE_WITH_YOUR_STORAGE_BUCKET",    // e.g. your-project.appspot.com
  messagingSenderId: "REPLACE_WITH_YOUR_MESSAGING_SENDER_ID",
  appId:             "REPLACE_WITH_YOUR_APP_ID",
};

/**
 * VAPID key for Web Push
 * Get it from:
 *   Firebase Console → Project Settings → Cloud Messaging
 *   → Web Push certificates → Key pair
 */
export const VAPID_KEY = "REPLACE_WITH_YOUR_VAPID_KEY";
